var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "share"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 15,
    height: 15,
    transform: "translate(39 143)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_628",
    "data-name": "Mask Group 628",
    transform: "translate(-39 -143)",
    clipPath: "url(#share)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_71_",
    "data-name": "svgexport-6 (71)",
    transform: "translate(39.972 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11481",
    "data-name": "Path 11481",
    d: "M10.6,10.09a2.45,2.45,0,0,0-1.816.8L4.743,8.39a2.446,2.446,0,0,0,0-1.78l4.042-2.5a2.455,2.455,0,1,0-.472-.761l-4.042,2.5a2.455,2.455,0,1,0,0,3.3l4.042,2.5A2.455,2.455,0,1,0,10.6,10.09ZM9.04,2.455a1.56,1.56,0,1,1,1.56,1.56,1.562,1.562,0,0,1-1.56-1.56ZM2.455,9.06A1.56,1.56,0,1,1,4.015,7.5,1.562,1.562,0,0,1,2.455,9.06ZM9.04,12.545A1.56,1.56,0,1,1,10.6,14.1,1.562,1.562,0,0,1,9.04,12.545Zm0,0",
    transform: "translate(0 0)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.647de3f10991810d83f483fecd7e9206.svg";
export { ForwardRef as ReactComponent };